<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        title="KEEP IN TOUCH"
        pace="6"
      >
        Have a question? Contact us below.
      </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessInfo',

    props: { dark: Boolean },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: 'Melbourne FL',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '321-271-7474',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'info@hackerhang.com',
        },
      ],
    }),
  }
</script>
